<template>
    <div :id="'radio--' + component_id">
        <div v-show="options_loaded && passed_filter && show_argon_option" class="designeroption">
            <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
                <span>
                    {{ title }}
                    <span v-if="show_help_text" data-designer-help-text="{{help_text}}">
                        <i class="fa fa-question-circle help-text-icon"></i>
                    </span>
                </span>
                <span v-for="option in filtered_option_list">
                    <label>
                        <input type="radio" v-model="localTarget" :name="'radio_' + component_id" :value="option.value"/>
                        {{ option.label }}
                    </label>
                </span>
                <div class="mt-3">
                    Planitherm Argon Filled Glass
                </div>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import RadioQuestion from "./mixin/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion
        ],
        props: {
            slab: {
              required: true,
            },
            title: {
                default(){
                    return 'Argon Glass:';
                }
            },
            component_id: {
                default(){
                    return 'argon_glass';
                }
            },
            help_text: {
                default(){
                    return '';
                }
            },
            show_help_text: {
                default(){
                    return false;
                }
            },
        },
        computed: {
            filtered_option_list(){
                if (Array.isArray(this.option_list)) {
                    return this.option_list.filter((key) => {
                        return key.value !== null;
                    });
                } else {
                    return [];
                }
            },
            url(){
                return '/api/options/' + this.fabricator + '/argon-glass?slab=' + this.slab;
            },
            passed_filter(){
                return this.variable_ready(this.fabricator, this.slab);
            },
            cache_key(){
                return '_' + this.fabricator + '_' + this.slab;
            },
            show_argon_option(){
                return this.filtered_option_list.length > 1 || (this.filtered_option_list.length > 1 && this.filtered_option_list[0].value === 2);
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
